import Swiper from 'swiper/bundle'
import AOS from 'aos';

export default {
  init() {
    $('form input, form textarea, form select').focusin(function(){
      $(this).parent().siblings('label').addClass('focused');
    });

    $('form input, form textarea, form select').focusout(function(){
      var input = $(this);
      if( input.val().length === 0 ){
        input.parent().siblings('label').removeClass('focused');
      }
    });

    //on ajax submission
    $('#gform_ajax_frame_1, #gform_ajax_frame_2, #gform_ajax_frame_3').on( 'load', function(){
      $('form input, form textarea, form select').on('focusin', function(){
        $(this).parent().siblings('label').addClass('focused');
      });
      $('form input, form textarea, form select').focusout(function(){
        var input = $(this);
        if( input.val().length === 0 ){
          input.parent().siblings('label').removeClass('focused');
        }
      });
      $('form input, form textarea, form select').each(function(){
        if( $(this).val().length != 0 ){
          $(this).parent().siblings('label').addClass('focused');
        }
      });
    });

    $('.menu-item-has-children').on('click', function(){
      $('.menu-item-has-children').toggleClass('underline');
    }); 
    
    $('#home-page-total').on('click', function(){
      $('.sub-menu').removeClass('sub-menu-visible');
      $('.menu-item-has-children').removeClass('underline');
    });
    
    $('.menu-item:not(.menu-item-has-children').on('click', function(){
      $('.sub-menu').removeClass('sub-menu-visible');
      $('.menu-item-has-children').removeClass('underline');
    });

    $(function () {
      $('.content-reviews').slice(0, 6).show();
      $('body').on('click touchstart', '.load-more', function (e) {
        e.preventDefault();
        $('.content-reviews:hidden').slice(0, 2).slideDown();
        if ($('.content-reviews:hidden').length == 0) {
          $('.load-more').css('visibility', 'hidden');
        }
      });
    })

    $(function () {
      $('.news-slice').slice(0, 9).show();
      $('body').on('click touchstart', '.load-more', function (e) {
        e.preventDefault();
        $('.news-slice:hidden').slice(0, 3).slideDown();
        if ($('.news-slice:hidden').length == 0) {
          $('.load-more').css('visibility', 'hidden');
        }
      });
    })

    
    AOS.init();

    var swiper = new Swiper('.mySwiper', {
      spaceBetween: 30,
      hashNavigation: {
        watchState: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
  });
  
  swiper 


    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
